import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  LatestSurveyScore = 'LatestSurveyScore',
}

export const useGetLatestSurveyScore = (teamId: number) => {
  const { getLatestSurveyScore } = useServicesContext();
  return useQuery({
    queryKey: [CacheKey.LatestSurveyScore, teamId],
    queryFn: () => getLatestSurveyScore(teamId!),
    refetchInterval: 60000,
    enabled: Boolean(teamId)
  });
};
